import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_bar = _resolveComponent("app-bar")!
  const _component_navigation_drawer = _resolveComponent("navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { class: "font" }, {
    default: _withCtx(() => [
      _createVNode(_component_app_bar),
      _createVNode(_component_navigation_drawer),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, { class: "px-16 pt-16" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}